/* Independent layout lifecycle; Shopify section hosts are never reparented. */
(() => {
  const connections = new Map();
  const resolve = value => {
    if (!value) return null;
    const clean=value.replace(/^#/, '');
    return document.getElementById(clean) || document.getElementById('shopify-section-'+clean) || [...document.querySelectorAll('[id]')].find(n=>(n.getAttribute('id')||'').endsWith('__'+clean));
  };
  const restore = group => {
    for(const entry of connections.get(group)||[]) {
      if(entry.anchor.parentNode)entry.anchor.replaceWith(entry.content);
      entry.slot.remove();
    }
    connections.delete(group);delete group.dataset.icReady;
  };
  window.icSectionGroups = () => {
    for(const [group] of connections)if(!group.isConnected)restore(group);
    document.querySelectorAll('[data-ic-section-group]').forEach(group=>{
      if(connections.has(group))return;
      const hosts=[resolve(group.dataset.first),resolve(group.dataset.second)];
      if(hosts.some(n=>!n||n.contains(group))||hosts[0]===hosts[1])return;
      const roots=hosts.map(n=>n.matches('[id^="shopify-section-"]')?[...n.children].find(e=>e.matches('section,article,div.ic-section,div.icx-showcase')):n);
      if(roots.some(n=>!n||n.closest('.ic-group-slot')))return;
      const records=roots.map(content=>{
        const anchor=document.createComment('independent-layout-origin');content.before(anchor);
        const slot=document.createElement('div');slot.className='ic-group-slot';group.append(slot);slot.append(content);
        return {content,anchor,slot};
      });
      connections.set(group,records);group.dataset.icReady='true';
      document.dispatchEvent(new CustomEvent('ic:layout-ready'));
    });
  };
  document.addEventListener('shopify:section:unload',e=>{
    for(const [group,entries]of connections)if(e.target.contains(group)||entries.some(x=>e.target.contains(x.anchor)||e.target.contains(x.content)))restore(group);
  });
  document.addEventListener('shopify:section:load',()=>window.icSectionGroups());
  document.addEventListener('shopify:section:reorder',()=>{for(const [group]of connections)restore(group);window.icSectionGroups();});
  document.addEventListener('DOMContentLoaded',()=>window.icSectionGroups());
})();
